import React from 'react';

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
  text?: string;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  size?: 'small' | 'medium' | 'large';
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  phoneNumber = '+528182597917',
  message = 'Hola, me gustaría obtener más información',
  text = 'Contactar por WhatsApp',
  position = 'bottom-right',
  size = 'medium'
}) => {
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  const positionClasses = {
    'bottom-right': 'bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8',
    'bottom-left': 'bottom-4 left-4 sm:bottom-6 sm:left-6 md:bottom-8 md:left-8',
    'top-right': 'top-4 right-4 sm:top-6 sm:right-6 md:top-8 md:right-8',
    'top-left': 'top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8'
  };

  const sizeClasses = {
    small: 'w-10 h-10 sm:w-12 sm:h-12',
    medium: 'w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16',
    large: 'w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20'
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      className={`
        fixed ${positionClasses[position]} ${sizeClasses[size]}
        flex items-center justify-center
        bg-green-500 hover:bg-green-600
        rounded-full shadow-lg hover:shadow-xl
        transform hover:scale-110
        transition-all duration-300 ease-in-out
        cursor-pointer z-50
      `}
      tabIndex={0}
      aria-label={text}
    >
      <img
        src="/assets/icons/whatsapp.svg"
        alt="WhatsApp"
        className="w-3/4 h-3/4 object-contain"
      />
      <span className="sr-only">{text}</span>
    </div>
  );
};

export default WhatsAppButton;
